<template>
  <div id="login-container" class="login-container">
    <div class="row">
      <div class="col-md-12">
        <div class="text-center m-b-md">
          <h4>The LEA platform is no longer accessible through the Schneider Electric network.</h4>
        </div>
        <div class="hpanel">
          <div class="panel-body">
            <div class="form-group">
              <p class="text-center "><strong>For enquiries about LEA or ideXlab platform,<br> you may contact <a class="text-info" href="mailto:support-idexlab@group-gac.com">support-idexlab@group-gac.com</a> </strong></p>
            </div>
            <!--<form id="loginForm">
              <div class="form-group">
                <p class="text-center"><strong>Schneider Electric uses your network username and password to login to LEA. Continue to login to LEA through your network.</strong></p>
              </div>
              <div class="row">
                <div class="col-md-2 col-xs-12"></div>
              <vue-ladda type="button" class="btn btn-success col-md-8 col-xs-12" @click="loginPingSSO" tabindex="1" :loading="pingSsoButton.loading" :data-style="pingSsoButton.dataStyle"> Continue</vue-ladda>
                <div class="col-md-2 col-xs-12"></div>
              </div>
                <div class="text-center" style="margin-top: 10px">
                <a href="https://app.idexlab.com" class="text-info" target="_blank">Not a part of Schneider Electric?</a>
                </div>
            </form>-->
          </div>
        </div>
      <!--  <div >
          <h3 class="text-center">Welcome to the LEA platform</h3>
          <p class="text-justify">
            Schneider Digital has provided you with an Single Sign On-enabled, LEA account to connecting to internal (Edison) and to external expertise
          </p>
        </div>
        <div  class="m-b">
          <h4 class="text-center text-info" data-toggle="popover" v-bind:data-content="leaQuickStarterGuide"  data-original-title="" title="">LEA QuickStarter guide <i class="fa fa-info-circle text-success"></i></h4>
        </div>-->
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-center">
        <strong><a href="https://www.idexlab.com" target="_blank"> LEA is powered by IDEXLAB</a></strong><br/><br> {{year}} Copyright Idexlab
      </div>
    </div>
  </div>

</template>

<style>
  #login-container  .popover{max-width: initial}
</style>
<script>
import VueLadda from 'vue-ladda'
import VueCookies from 'vue-cookies'
export default {
  components: {VueLadda},
  name: 'loginSE',
  data () {
    return {
      pingSsoButton: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      year: new Date().getFullYear(),
      leaQuickStarterGuide: ''
    }
  },
  methods: {
    connectUsingSSO (code) {
      let self = this
      this.pingSsoButton.loading = true
      let redirect = this.$auth.redirect()
      this.axios.get('/auth/ping-sso/callback?code=' + code)
        .then((response) => {
          let goTo
          self.$auth.token(null, response.data.access_token)
          VueCookies.set('rememberMe', true)
          self.$auth.watch.data = response.data.data // user object
          self.$auth.watch.authenticated = true
          if (this.$auth.user() && this.$user.isBasic()) {
            goTo = {name: 'SearchSimple'}
          } else {
            goTo = {name: (redirect ? redirect.from.name : 'Dashboard'), params: redirect ? redirect.from.params : {}, query: redirect ? redirect.from.query : {}}
          }
          this.$router.replace(goTo)
          this.$salesMachine.signIn()
          this.pingSsoButton.loading = false
        })
        .catch((error) => {
          this.pingSsoButton.loading = false
        })
    },
    loginPingSSO: function (event) {
      event.preventDefault()
      window.location.href = process.env.LOGIN_PING_SSO_URL
    }
  },
  mounted () {
    $('[data-toggle="popover"]').popover({
      trigger: 'hover',
      placement: 'top',
      container: '#login-container',
      html: true
    })

    document.title = 'LEA platform – Login'
  },
  beforeMount () {
    this.leaQuickStarterGuide = '<div>' +
      '<h3 class="text-center">1\' reading before using LEA application</h3> <ul>' +
      '<li class="m-b"> Recommended browser <strong class="text-success">Chrome</strong> - Firefox - Safari - ... Don\'t use Internet Explorer!</li>' +
      '<li class="m-b">LEA is only available through the Schneider-Electric network; ' +
      '<ul class="m-t-sm">' +
      '<li class="m-b-xs">From external places (home, hotel, ...), you should use a <strong class="text-success">VPN</strong>,</li>' +
      '<li><strong class="text-success">Global Protect</strong> manages automatically the VPN connection.</li>' +
      '</ul></li>' +
      '<li class="m-b">LEA is compliant with SE Cybersecurity & GDPR policy</li>' +
      '<li class="m-b">The user is identified through <strong class="text-success">Single Sign On/Ping ID</strong> </li>' +
      '</ul></div>'

    if (this.$route.query.state === 'sso-ping') {
      this.connectUsingSSO(this.$route.query.code)
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/login/loginSE.vue